/** The signed-in shell every page repeats: the account menu. */
export const shell = {
  account: 'Account',
  teamPlan: 'Team plan',
  personalPlan: 'Personal plan',
  settings: 'Settings',
  admin: 'Admin',
  helpDocs: 'Help & docs',
  desktopApp: 'Get desktop app',
  website: 'Doop website',
  appearance: 'Appearance',
  language: 'Language',
  logOut: 'Log out',
} as const
